import { APP } from '../tokens';

const F = APP.fontFamily;

interface CoTDocumentChipProps {
  filename: string;
  source?: string;
  variant?: 'pdf' | 'default';
}

function DocIcon() {
  return (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" style={{ flexShrink: 0 }}>
      <rect width="12" height="12" rx="2" fill="#D97645" opacity={0.15} />
      <path
        d="M3 4H9M3 6H9M3 8H7"
        stroke="#D97645"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function CoTDocumentChip({ filename, source }: CoTDocumentChipProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 6,
        paddingBlock: 5,
        paddingInline: 8,
        gap: 6,
        border: `1px solid ${APP.border}`,
        backgroundColor: APP.bgCardBody,
      }}
    >
      <DocIcon />
      <span
        style={{
          fontSize: 11,
          fontWeight: 400,
          color: APP.textPrimary,
          lineHeight: '14px',
          fontFamily: F,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}
      >
        {filename}
      </span>
      {source && (
        <span
          style={{
            fontSize: 10,
            fontWeight: 400,
            color: APP.textMuted,
            lineHeight: '12px',
            fontFamily: F,
            flexShrink: 0,
          }}
        >
          {source}
        </span>
      )}
    </div>
  );
}
